import ApplicationRequest from "../../components/windows/applicationRequest";
import CreateWindowsPolicy from "../../components/windows/createWindowsPolicy";
import JitConnections from "../../components/windows/jitConnections";
import JitPolicy from "../../components/windows/jitPolicy";
import CreateSimplifiedAccessPolicy from "../../components/windows/simplifiedAccessPolicy";
import WindowsEndpoints from "../../components/windows/windowsPam";
import AuditLogs from "../../components/windows/auditLogs";
import EndpointPolicies from "../../components/windows/endpointPolicies";
import RequestLogs from "../../components/windows/request";
import LockoutDiagnostics from "../../components/windows/lockoutDiagnostics";

const windowsRouter = [
    { path: "endpoints", element: <WindowsEndpoints /> },
    { path: "jit", element: <JitPolicy /> },
    { path: "jitConnections", element: <JitConnections /> },
    { path: "createWindowPolicy", element: <CreateWindowsPolicy /> },
    { path: "createSimplifiedAccessPolicy", element: <CreateSimplifiedAccessPolicy /> },
    { path: "applicationRequest", element: <ApplicationRequest /> },
    { path: "auditLogs", element: <AuditLogs /> },
    { path: "accountLockoutEvents", element: <LockoutDiagnostics /> },
    { path: "endpointPolicies", element: <EndpointPolicies /> },
    { path: "requestLogs", element: <RequestLogs /> },

];

export default windowsRouter;